/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Topic_ChippingInputs */

const en_practice_topic_chipping = /** @type {(inputs: Practice_Topic_ChippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chipping`)
};

const es_practice_topic_chipping = /** @type {(inputs: Practice_Topic_ChippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chipping`)
};

const de_practice_topic_chipping = /** @type {(inputs: Practice_Topic_ChippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chippen`)
};

const zh_practice_topic_chipping = /** @type {(inputs: Practice_Topic_ChippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切杆`)
};

const ar_practice_topic_chipping = /** @type {(inputs: Practice_Topic_ChippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الشيب`)
};

const fr_practice_topic_chipping = /** @type {(inputs: Practice_Topic_ChippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chipping`)
};

const vi_practice_topic_chipping = /** @type {(inputs: Practice_Topic_ChippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chipping`)
};

const sw_practice_topic_chipping = /** @type {(inputs: Practice_Topic_ChippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chipping`)
};

const th_practice_topic_chipping = /** @type {(inputs: Practice_Topic_ChippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชิพ`)
};

const bs_practice_topic_chipping = /** @type {(inputs: Practice_Topic_ChippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chipping`)
};

const ja_practice_topic_chipping = /** @type {(inputs: Practice_Topic_ChippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チップ`)
};

const ko_practice_topic_chipping = /** @type {(inputs: Practice_Topic_ChippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`칩샷`)
};

const pt_practice_topic_chipping = /** @type {(inputs: Practice_Topic_ChippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chip`)
};

const it_practice_topic_chipping = /** @type {(inputs: Practice_Topic_ChippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chipping`)
};

const sv_practice_topic_chipping = /** @type {(inputs: Practice_Topic_ChippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chipping`)
};

const nl_practice_topic_chipping = /** @type {(inputs: Practice_Topic_ChippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chippen`)
};

const da_practice_topic_chipping = /** @type {(inputs: Practice_Topic_ChippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chipping`)
};

const nb_practice_topic_chipping = /** @type {(inputs: Practice_Topic_ChippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chipping`)
};

const fi_practice_topic_chipping = /** @type {(inputs: Practice_Topic_ChippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chippaus`)
};

const pl_practice_topic_chipping = /** @type {(inputs: Practice_Topic_ChippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chipping`)
};

const ru_practice_topic_chipping = /** @type {(inputs: Practice_Topic_ChippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чиппинг`)
};

const tr_practice_topic_chipping = /** @type {(inputs: Practice_Topic_ChippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chip atışı`)
};

const hi_practice_topic_chipping = /** @type {(inputs: Practice_Topic_ChippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चिपिंग`)
};

const id_practice_topic_chipping = /** @type {(inputs: Practice_Topic_ChippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chipping`)
};

const ms_practice_topic_chipping = /** @type {(inputs: Practice_Topic_ChippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chipping`)
};

const cs_practice_topic_chipping = /** @type {(inputs: Practice_Topic_ChippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chipping`)
};

const el_practice_topic_chipping = /** @type {(inputs: Practice_Topic_ChippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τσιπ`)
};

const he_practice_topic_chipping = /** @type {(inputs: Practice_Topic_ChippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`צ׳יפינג`)
};

const af_practice_topic_chipping = /** @type {(inputs: Practice_Topic_ChippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chip`)
};

const hu_practice_topic_chipping = /** @type {(inputs: Practice_Topic_ChippingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chippelés`)
};

/**
* | output |
* | --- |
* | "Chipping" |
*
* @param {Practice_Topic_ChippingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const practice_topic_chipping = /** @type {((inputs?: Practice_Topic_ChippingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Topic_ChippingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_practice_topic_chipping(inputs)
	if (locale === "de") return de_practice_topic_chipping(inputs)
	if (locale === "zh") return zh_practice_topic_chipping(inputs)
	if (locale === "ar") return ar_practice_topic_chipping(inputs)
	if (locale === "fr") return fr_practice_topic_chipping(inputs)
	if (locale === "vi") return vi_practice_topic_chipping(inputs)
	if (locale === "sw") return sw_practice_topic_chipping(inputs)
	if (locale === "th") return th_practice_topic_chipping(inputs)
	if (locale === "bs") return bs_practice_topic_chipping(inputs)
	if (locale === "ja") return ja_practice_topic_chipping(inputs)
	if (locale === "ko") return ko_practice_topic_chipping(inputs)
	if (locale === "pt") return pt_practice_topic_chipping(inputs)
	if (locale === "it") return it_practice_topic_chipping(inputs)
	if (locale === "sv") return sv_practice_topic_chipping(inputs)
	if (locale === "nl") return nl_practice_topic_chipping(inputs)
	if (locale === "da") return da_practice_topic_chipping(inputs)
	if (locale === "nb") return nb_practice_topic_chipping(inputs)
	if (locale === "fi") return fi_practice_topic_chipping(inputs)
	if (locale === "pl") return pl_practice_topic_chipping(inputs)
	if (locale === "ru") return ru_practice_topic_chipping(inputs)
	if (locale === "tr") return tr_practice_topic_chipping(inputs)
	if (locale === "hi") return hi_practice_topic_chipping(inputs)
	if (locale === "id") return id_practice_topic_chipping(inputs)
	if (locale === "ms") return ms_practice_topic_chipping(inputs)
	if (locale === "cs") return cs_practice_topic_chipping(inputs)
	if (locale === "el") return el_practice_topic_chipping(inputs)
	if (locale === "he") return he_practice_topic_chipping(inputs)
	if (locale === "af") return af_practice_topic_chipping(inputs)
	if (locale === "hu") return hu_practice_topic_chipping(inputs)
	return en_practice_topic_chipping(inputs)
});